import React, { useEffect } from "react";

const ZohoWidget = () => {
  useEffect(() => {
    // Load Zoho Desk widget script for iframe
    const script = document.createElement("script");
    script.src =
      "https://desk.zoho.com/portal/api/feedbackwidget/1163480000000353065?orgId=894422386&displayType=iframe";
    script.async = true;

    document.head.appendChild(script);

    // Cleanup function
    return () => {
      const existingScript = document.querySelector(
        'script[src*="desk.zoho.com"]'
      );
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="w-full flex justify-center">
      <iframe
        id="zsfeedbackFrame"
        width="890"
        height="570"
        name="zsfeedbackFrame"
        scrolling="no"
        allowtransparency="false"
        frameBorder="0"
        border="0"
        src="https://desk.zoho.com/support/fbw?formType=AdvancedWebForm&fbwId=edbsn2b436ad80309aa72ad1a6c2f360df9441dfd6d95adc03b29be8fac183a8a347c&xnQsjsdp=edbsn50af0c007fcac7ff637210dbba58552d&mode=showNewWidget&displayType=iframe"
        className="w-full max-w-full lg:max-w-4xl border-0 rounded-lg shadow-sm"
        title="Support Ticket Form"
      />
    </div>
  );
};

export default ZohoWidget;
